// src/resources/sections/ipamConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const IPAM_CONFIG: ResourceConfig[] = [
  {
    name: "vrfs",
    label: "VRFs",
    schema: "ipam",
    fields: [
      {
        source: "name",
        label: "name",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["name"],
  },

  {
    name: "ip_addresses",
    label: "IP Addresses",
    schema: "ipam",
    fields: [
      { source: "address", kind: "inet", list: true, form: true },
      { source: "hostname_fqdn", kind: "text", list: true, form: true },
      { source: "description", kind: "longtext", list: true, form: true },
    ],

    // Optional: you can omit these now; provider derives from kinds.
    searchFields: ["hostname_fqdn", "description"],
    // inetSearchFields: ["address"],
  },

  {
    name: "prefixes",
    label: "Prefixes",
    schema: "ipam",
    fields: [
      {
        source: "prefix",
        label: "prefix",
        kind: "cidr",
        list: true,
        form: true,
      },
      {
        source: "parent_id",
        label: "Parent Prefix",
        kind: "uuid",
        form: true,
        list: true,
        ref: {
          resource: "prefixes",
          optionText: "prefix",
          input: "autocomplete",
          schema: "ipam",
        },
      },
      {
        source: "vrf_id",
        label: "VRF Name",
        kind: "uuid",
        form: true,
        list: true,
        ref: {
          resource: "vrfs",
          optionText: "name",
          input: "autocomplete",
          schema: "ipam",
        },
      },
    ],
    searchFields: ["prefix"],
  },
  {
    name: "ip_status_types",
    label: "Prefixes",
    schema: "ipam",
    fields: [
      {
        source: "prefix",
        label: "prefix",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    inetSearchFields: ["prefix_status_typees"],
  },
  {
    name: "prefix_status_types",
    label: "Prefixes",
    schema: "ipam",
    fields: [
      {
        source: "prefix",
        label: "prefix",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    inetSearchFields: ["prefix"],
  },
];
